module.exports = __webpack_public_path__ + "img/February.da50a845.png";